export class DateFormatter {
  format(time: number, mask: string): string {
    const date = this.getDate(time)

    const h = this.leadZero(date.getHours())
    const i = this.leadZero(date.getMinutes())
    const s = this.leadZero(date.getSeconds())
    const y = this.leadZero(date.getFullYear())
    const d = this.leadZero(date.getDate())
    const m = this.leadZero(date.getMonth() + 1)

    const wday = date.toLocaleDateString('en-EN', { weekday: 'long' })
    const mnth = date.toLocaleDateString('en-EN', { month: 'long' })

    return mask.replace(/%y/g, y).replace(/%m/g, m).replace(/%d/g, d).replace(/%h/g, h).replace(/%i/g, i).replace(/%s/g, s).replace(/%w/g, wday).replace(/%M/g, mnth)
  }

  leadZero(num: number): string {
    return (num < 10) ? '0' + num : '' + num
  }

  getDayOfYear(time: number): number {
    const now: Date = this.getDate(time)
    const start: Date = new Date(now.getFullYear(), 0, 0)
    const diff = (now.getTime() - start.getTime()) + ((start.getTimezoneOffset() - now.getTimezoneOffset()) * 60 * 1000)
    const oneDay: number = 1000 * 60 * 60 * 24
    return Math.floor(diff / oneDay)
  }

  getDate(time: number): Date {
    if (!(time > 0))
      return new Date()

    // seconds -> milliseconds
    const ts = ((time + '').length < 11) ? time * 1000 : time

    return new Date(ts)
  }
}